
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16.32 16.44"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M11.53 8.9a3.49 3.49 0 0 1-1.83-.65l.6-.8s1.1.81 1.83.25c.18-.18 1.76-1.65 2.59-2.32a1.68 1.68 0 0 0 .33-2.2 8.2 8.2 0 0 0-1.37-1.56 1.87 1.87 0 0 0-2.32-.36S9.23 3 8.61 3.64a2.73 2.73 0 0 0-.23 1.88l-1 .16c0-.2-.29-1.94.52-2.74.66-.66 2.75-2.38 2.84-2.46a2.85 2.85 0 0 1 3.61.39 9.23 9.23 0 0 1 1.55 1.78 2.66 2.66 0 0 1-.55 3.5c-.84.68-2.54 2.27-2.55 2.29a1.93 1.93 0 0 1-1.27.46zM4.33 16.44a3 3 0 0 1-1.67-.52A7.38 7.38 0 0 1 .38 14a3.06 3.06 0 0 1 .18-3.24c.62-.87 1.5-1.94 2-2.52L2.73 8a2.58 2.58 0 0 1 2.73-.46l-.36.93a1.68 1.68 0 0 0-1.59.16l-.2.24c-.46.57-1.33 1.63-1.93 2.47a2 2 0 0 0-.13 2.16 7.25 7.25 0 0 0 2 1.64c.55.36 1.56.56 2 0a29.82 29.82 0 0 0 2.4-3.18 1.58 1.58 0 0 0-.17-1.7l.78-.63a2.58 2.58 0 0 1 .26 2.83A32.15 32.15 0 0 1 6 15.66a2 2 0 0 1-1.67.78z"}}),_c('path',{staticClass:"cls-1",attrs:{"transform":"rotate(-41.79 9.9 5.866)","d":"M7.69 5.37h4.42v1H7.69z"}}),_c('path',{staticClass:"cls-1",attrs:{"transform":"rotate(-53.08 5.624 9.951)","d":"M3.31 9.45h4.62v1H3.31z"}}),_c('path',{staticClass:"cls-1",attrs:{"transform":"rotate(-89.66 6.453 3.135)","d":"M5.3 2.64h2.31v1H5.3z"}}),_c('path',{staticClass:"cls-1",attrs:{"transform":"rotate(-45.11 4.207 3.907)","d":"M3.7 1.57h1v4.66h-1z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M2.1 5.95h2.51v1H2.1z"}})])])])
          )
        }
      }
    